import { rgba } from "polished";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import ButtonAtm from "../../atoms/ButtonAtm";
import TextAtm from "../../atoms/TextAtm";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import PushOrg from "../../organisms/PushOrg";
import RelativeContainerOrg from "../../organisms/RelativeContainerOrg";
export var StyledFlexContainerOrg = styled(FlexContainerOrg).withConfig({
  componentId: "sc-hgstsg-0"
})(["width:fit-content;", "{flex-direction:column-reverse;}"], breakpoint("small", "large"));
export var HoverContainer = styled.div.withConfig({
  componentId: "sc-hgstsg-1"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;position:absolute;top:0;right:0;bottom:0;left:0;flex-direction:column;align-items:center;justify-content:center;background:", ";@media (hover:none){display:none;}", "{position:relative;margin-top:", ";background:transparent;@media (hover:none){display:block;}}", "{margin-top:", ";}"], rgba(getColor(theme, "backgroundDarker"), 0.8), breakpoint("small", "large"), space(3), breakpoint("small", "medium"), space(2));
});
export var StyledRelativeContainerOrg = styled(RelativeContainerOrg).withConfig({
  componentId: "sc-hgstsg-2"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["display:inline-block;overflow:hidden;border-radius:", ";box-shadow:", ";&:not(:hover) ", "{display:none;}", "{box-shadow:none;&:not(:hover) ", "{display:flex;}}"], getBorderRadius(theme, "medium"), getBoxShadow(theme, "large"), HoverContainer, breakpoint("small", "large"), HoverContainer);
});
export var StyledButtonAtm = styled(ButtonAtm).withConfig({
  componentId: "sc-hgstsg-3"
})(function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return css(["display:", ";min-width:", ";", "{display:", ";}", "{width:100%;}"], !$isMobile ? "inline-block" : "none", space(27), breakpoint("small", "large"), !$isMobile ? "none" : "inline-block", breakpoint("small", "medium"));
});
export var SecondButtonWrapper = styled(PushOrg).withConfig({
  componentId: "sc-hgstsg-4"
})(["", "{width:100%;}"], breakpoint("small", "medium"));
export var TextAtmWrapper = styled(PushOrg).withConfig({
  componentId: "sc-hgstsg-5"
})(["", "{margin-top:0;margin-bottom:", ";}", "{width:100%;margin-bottom:", ";}"], breakpoint("small", "large"), space(3), breakpoint("small", "medium"), space(2));
export var StyledTextAtm = styled(TextAtm).withConfig({
  componentId: "sc-hgstsg-6"
})(["", "{text-align:center;}"], breakpoint("small", "large"));